/**
 * BHA / Bit screen — the standalone `/bha` route. Resolves the current well's
 * active event and renders the runs + bit + schematic panel. The event's unit
 * profile drives every measurement conversion in the panel.
 */
import { useLocale } from "@hooks/useLocale";
import { useCurrentWell } from "@hooks/useCurrentWell";
import { QueryState } from "@components/ui/QueryState";
import { BhaPanel } from "./BhaPanel";

export function BhaBit() {
  const { t } = useLocale();
  const { well, activeEvent, isLoading, isError } = useCurrentWell();

  return (
    <div className="bha-screen">
      <div className="page-head">
        <h1>{t("bha.title")}</h1>
        {well ? (
          <div className="chip-ctx">
            <span className="k">{t("nav.wellRecord")}</span>
            <span className="mono">{well.apiNo ?? well.uwi}</span>
            {activeEvent?.event_type ? (
              <>
                <span className="dim">·</span>
                <span>{activeEvent.event_type}</span>
              </>
            ) : null}
          </div>
        ) : (
          <p className="subtitle">{t("well.notSelected")}</p>
        )}
      </div>

      <QueryState
        isLoading={isLoading}
        isError={isError}
        isEmpty={!activeEvent}
        emptyMessage={t("well.event.noEvents")}
      >
        {activeEvent ? (
          <BhaPanel eventId={activeEvent.id} storedProfile={activeEvent.unit_profile_key} />
        ) : null}
      </QueryState>
    </div>
  );
}
